const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目基本情况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '公告内容',
        },
    },
    {
        component: 'html-reader',
        options: {
            data: '',
        },
    },
    {
        component: 'ZlmTitle',
        options: {
          size: 'medium',
          text: '公告附件',
        },
      },
      {
        component: 'file-list',
        options: {
          list: '',
        },
      },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '标段/标包信息',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '包件',
            data: [],
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/home/cgggDetail`, {
                ggGuid: this.$route.query.ggGuid,
                gcGuid: this.$route.query.gcGuid,
            }, { showLoading: true }).then((res) => {
                this.config[5].options.list = res.data.ggFuJianArr.map((t) => ({
                    name: t.ggFuJianName,
                    url: t.ggFuJianUrl,
                }))
                this.config[3].options.data = res.data.gg.ggContent
                this.config[1].options.data = {
                    '项目名称': res.data.zbgc.gcName,
                    '项目编号': res.data.zbgc.gcBH,
                    '项目类型': getProjectTypeName(res.data.zbgc.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.zbgc.zbFangShi),
                    '所属行业分类': res.data.hangYe,
                    '项目实施地点': '',
                    '招标人': res.data.qiYe.qiYe_Name,
                    '代理机构': res.data.zbgc.zbdlName,
                    // '公告附件': '',
                    // '公告内容': res.data.ggContent,
                }
                if (res.data.zbgc.xiangmuXingzhi === 3) {
                    this.config[1].options.data['经营资产交易类型'] = res.data.zbgc.jyzcTransType === 1 ? '资产处置' : '租赁'
                }
                this.config[7].options.data = res.data.ggBDs.map((t) => ({
                    '包件名称': t.bd.bdName,
                    '包件编号': t.bd.bdBH,
                    '文件获取开始时间': this.$util.timeFormatter(t.zbWJHuoQuStartTime),
                    '文件获取截止时间': this.$util.timeFormatter(t.zbWJHuoQuEndTime),
                    '澄清截止时间': this.$util.timeFormatter(t.zbWJDaYiEndTime),
                    '截标/开标时间': this.$util.timeFormatter(t.kbTime),
                    '标书获取地点': t.shouBiaoDiDian,
                    '开标地点': t.kbDiDian,
                }))
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
